import { generateTheme } from '@cld/theme-helper';
import { dark } from '@cld/themes';

export const theme = {
  ...generateTheme(dark),
};
